// 大赛动态数据
const dsdtData = [
  {
    id: 1, name: "2024年朝阳区中小学生“智慧农业杯”科普行动招募通知", html: `
<p style="text-indent: 28px">
    在这个充满活力的夏天，我们诚挚地邀请您加入一场别开生面的学习盛宴——“智慧农业杯”科普活动！共同开启新农人之旅...这不仅是一场知识的探险，更是一次深入了解科技如何改变农业、助力乡村振兴的奇妙旅程。让我们携手，从6月到9月，一起探索智慧农业的广阔天地，播种知识，收获未来！
</p>
<p style="text-indent: 28px">
    【活动时间】：2023年6月至9月
</p>
<p style="text-indent: 28px">
    <span>【参赛对象】：中小学生</span>
</p>
<p style="text-indent: 28px">
    <span>【组别设置】：</span>
</p>
<p style="text-indent: 28px">
    小学低年级组（1-3年级）；小学高年级组（4-6年级）组；初中组
</p>
<p style="text-indent: 28px">
    <span>【活动亮点】：</span>
</p>
<p >
    <span style="font-weight:bold;font-size:30px;vertical-align: -6px;">◆</span>&nbsp;&nbsp;<strong><span>双线模式</span></strong><span>：结合线上线下的灵活参与方式，无论你身在何处，都能轻松加入。</span>
</p>
<p >
    <span style="font-weight:bold;font-size:30px;vertical-align: -6px;">◆</span>&nbsp;&nbsp;<strong><span>四大阶段</span></strong>：预热招募（智慧农场参观）→初选（线上答题）→复选（线上答题+线下实践）→总决选及专家论坛。
</p>
<p >
    <span style="font-weight:bold;font-size:30px;vertical-align: -6px;">◆</span>&nbsp;&nbsp;<strong><span>综合提升</span></strong><span>：涵盖专业培训、在线知识竞答、实地参观智慧农场、实践操作、专家评选等多元化环节。</span>
</p>
<p >
    <span style="font-weight:bold;font-size:30px;vertical-align: -6px;">◆</span>&nbsp;&nbsp;<strong><span>专家面对面</span></strong><span>：总决选期间，与行业专家近距离交流，参加高端论坛，拓宽视野。</span>
</p>
<p style="text-indent: 28px">
    <span>【参赛流程】</span>
</p>
<table cellspacing="0" width="595" style="margin:0 auto">
    <tbody>
        <tr style="height:19px" class="firstRow">
            <td width="154" valign="center" style="padding: 0px 7px; border-width: 1px; border-color: rgb(0, 0, 0);">
                <p style="text-indent:0;text-autospace:ideograph-numeric;text-align:center;vertical-align:middle">
                    <strong><span>事项</span></strong>
                </p>
            </td>
            <td width="224" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top-width: 1px; border-top-color: rgb(0, 0, 0); border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
                <p style="text-indent:0;text-autospace:ideograph-numeric;text-align:center;vertical-align:middle">
                    <strong><span>具体内容</span></strong>
                </p>
            </td>
            <td width="217" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top-width: 1px; border-top-color: rgb(0, 0, 0); border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
                <p style="text-indent:0;text-autospace:ideograph-numeric;text-align:center;vertical-align:middle">
                    <strong><span>时间</span></strong>
                </p>
            </td>
        </tr>
        <tr style="height:19px">
            <td width="154" valign="center" style="padding: 0px 7px; border-left-width: 1px; border-left-color: rgb(0, 0, 0); border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
                <p style="text-indent:0;text-autospace:ideograph-numeric;text-align:center;vertical-align:middle">
                    <span>报名阶段</span>
                </p>
            </td>
            <td width="224" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
                <p style="text-indent: 0;vertical-align: middle">
                    <span>线上初选报名及初选事项</span>
                </p>
            </td>
            <td width="217" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom: none;">
                <p style="text-indent: 0;vertical-align: middle">
                    <span>6月10日-7月8日（下午13:00）</span>
                </p>
            </td>
        </tr>
        <tr style="height:19px">
            <td width="154" valign="center" rowspan="3" style="padding: 0px 7px; border-left-width: 1px; border-left-color: rgb(0, 0, 0); border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
                <p style="text-indent:0;text-autospace:ideograph-numeric;text-align:center;vertical-align:middle">
                    <span>初选</span>
                </p>
            </td>
            <td width="224" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
                <p style="text-indent: 0;vertical-align: middle">
                    <span>智慧农场实地参观讲解</span>
                </p>
            </td>
            <td width="217" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top-width: 1px; border-top-color: rgb(0, 0, 0); border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
                <p style="text-indent: 0;vertical-align: middle">
                    <span>6月22日、7月8日</span>
                </p>
            </td>
        </tr>
        <tr style="height:19px">
            <td width="224" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
                <p style="text-indent: 0;vertical-align: middle">
                    <span>线上答题</span>
                </p>
            </td>
            <td width="217" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
                <p style="text-indent: 0;vertical-align: middle">
                    <span>7月9日-7月11日</span>
                </p>
            </td>
        </tr>
        <tr style="height:19px">
            <td width="224" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
                <p style="text-indent: 0;vertical-align: middle">
                    <span>发布复选名单及通知</span>
                </p>
            </td>
            <td width="217" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom: none;">
                <p style="text-indent: 0;vertical-align: middle">
                    <span>7月12日</span>
                </p>
            </td>
        </tr>
        <tr style="height:19px">
            <td width="154" valign="center" rowspan="3" style="padding: 0px 7px; border-left-width: 1px; border-left-color: rgb(0, 0, 0); border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
                <p style="text-indent:0;text-autospace:ideograph-numeric;text-align:center;vertical-align:middle">
                    <span>复选</span>
                </p>
            </td>
            <td width="224" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
                <p style="text-indent: 0;vertical-align: middle">
                    <span>智慧农业实地体验活动</span>
                </p>
            </td>
            <td width="217" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top-width: 1px; border-top-color: rgb(0, 0, 0); border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
                <p style="text-indent: 0;vertical-align: middle">
                    <span>7月13日-7月14日</span>
                </p>
            </td>
        </tr>
        <tr style="height:19px">
            <td width="224" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
                <p style="text-indent: 0;vertical-align: middle">
                    <span>提交复选作品</span>
                </p>
            </td>
            <td width="217" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
                <p style="text-indent: 0;vertical-align: middle">
                    <span>7月15日-8月24日</span>
                </p>
            </td>
        </tr>
        <tr style="height:19px">
            <td width="224" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
                <p style="text-indent: 0;vertical-align: middle">
                    <span>发布总决选名单及通知</span>
                </p>
            </td>
            <td width="217" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
                <p style="text-indent: 0;vertical-align: middle">
                    <span>9月6日</span>
                </p>
            </td>
        </tr>
        <tr style="height:26px">
            <td width="154" valign="center" rowspan="3" style="padding: 0px 7px; border-left-width: 1px; border-left-color: rgb(0, 0, 0); border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
                <p style="text-indent:0;text-autospace:ideograph-numeric;text-align:center;vertical-align:middle">
                    <span>总决选</span>
                </p>
            </td>
            <td width="224" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
                <p style="text-indent: 0;vertical-align: middle">
                    <span>总决选</span>
                </p>
            </td>
            <td width="217" valign="center" rowspan="3" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
                <p style="text-indent: 0;vertical-align: middle">
                    <span>9月20日</span>
                </p>
            </td>
        </tr>
        <tr style="height:19px">
            <td width="224" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
                <p style="text-indent: 0;vertical-align: middle">
                    <span>智慧农业专家论坛</span>
                </p>
            </td>
        </tr>
        <tr style="height:19px">
            <td width="224" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
                <p style="text-indent: 0;vertical-align: middle">
                    <span>智慧农业现场活动体验日</span>
                </p>
            </td>
        </tr>
    </tbody>
</table>
<p style="text-indent: 28px">
    <span>【报名方式】：</span> 
</p>
<p style="text-indent: 28px">
    <span>扫描下方二维码直接进入报名页面或点击以下链接填写报名信息。</span>
</p>
<p >
    <span style="font-size:30px;vertical-align: -6px;">◆</span>&nbsp;&nbsp;<span>报名二维码：</span>
</p>
<p style="text-autospace:ideograph-numeric;text-align:center">
       <img width="181" src="${require("../../assets/custom/clnyy/dataImgs/wz-1-1.png")}"/>
</p>
<p >
    <span style="font-size:30px;vertical-align: -6px;">◆</span>&nbsp;&nbsp;报名链接：https://www.wjx.top/vm/hK7b1qn.aspx# 
</p>
<p style="text-indent: 28px">
    <span>【奖励机制】：</span>
</p>
<p >
    <span style="font-weight:bold;font-size:30px;vertical-align: -6px;">◆</span>&nbsp;&nbsp;<strong><span>参赛学生</span></strong><span>作为农场的小小科普推广员，可申请志愿者时长。志愿项目二维码如下：</span>
</p>
<p style="text-indent:28px;text-autospace:ideograph-numeric;text-align:center">
    <img width="131" src="${require("../../assets/custom/clnyy/dataImgs/wz-1-2.png")}"/>
</p>
<p >
    <span style="font-weight:bold;font-size:30px;vertical-align: -6px;">◆</span>&nbsp;&nbsp;<strong><span>进入总决选的参赛学生</span></strong><span>同时可获得官方认证的获奖证书、京内研学活动、不同规格的农场时令蔬菜大礼包。其中京内研学活动根据组别不同可能涉及的场地如中科院植物研究所、颐和园、圆明园、中轴线等。</span>
</p>
<p >
    <span style="font-weight:bold;font-size:30px;vertical-align: -6px;">◆</span>&nbsp;&nbsp;<strong><span>辅导老师</span></strong><span>可获得优秀辅导教师证书、学科实践课程公寓合作机会及农场采摘大礼包。</span>
</p>
<p >
    <span style="font-size:30px;vertical-align: -6px;">◆</span>&nbsp;&nbsp;<span>最终优胜者的</span><strong><span>所在班级</span></strong><span>还可以赢得免费的智慧劳动主题综合实践活动。</span>
</p>
<p style="text-indent: 28px">
    <span>&nbsp;</span>
</p>
<p style="text-indent: 28px">
    <span>来吧，让我们在这个夏天，共同书写智慧农业的新篇章！</span>
</p>
<p>
    <span>&nbsp;</span>
</p>
<p style="text-autospace:ideograph-numeric;text-align:right">
    <span>“智慧农业杯”科普活动组委会</span>
</p>
<p style="text-autospace:ideograph-numeric;text-align:right">
    <span>2024年6月10日</span>
</p>
<p style="height:10px;">
    <br/>
</p>`,
  },
  {
    id: 2, name: "2024年朝阳区中小学生“智慧农业杯”科普活动智慧农场参观日邀请通知",
    html: `
<p style="text-indent:28px;line-height:150%">
    <span style="line-height:150%;"><span>为了激发广大中小学生对农业科技的兴趣，促进中小学生对智慧农业的进一步认识，“智慧农业杯”科普活动组委会携手北京朝来农艺园共同举办智慧农场线下参观科普活动，诚挚邀请各位报名参加2024年朝阳区中小学生“智慧农业杯”科普活动的中小学生来园参观。
</p>
<p style="text-indent:28px;line-height:150%">
    <span style="line-height:150%;">【活动主题】：智慧农场参观日</span>
</p>
<p style="text-indent:28px;line-height:150%">
    <span style="line-height:150%;"><span>【活动对象】：“智慧农业杯”科普活动报名学生
</p>
<p style="text-indent:28px;line-height:150%">
    <span style="line-height:150%;">【组织形式】：分组参观</span>
</p>
<p style="text-indent:28px;line-height:150%">
    <span style="line-height:150%;">【活动时间】：</span>
</p>
<table cellspacing="0">
    <tbody>
        <tr class="firstRow">
            <td width="189" valign="top" style="padding: 0px 7px; border-width: 1px; border-color: windowtext;">
                <p style="text-indent:28px;text-align:center;line-height:150%">
                    <span style="line-height:150%;">组别</span>
                </p>
            </td>
            <td width="189" valign="top" style="padding: 0px 7px; border-width: 1px; border-color: windowtext;">
                <p style="text-indent:28px;text-align:center;line-height:150%">
                    <span style="line-height:150%;">2024年6月22日</span>
                </p>
            </td>
            <td width="189" valign="top" style="padding: 0px 7px; border-width: 1px; border-color: windowtext;">
                <p style="text-indent:28px;text-align:center;line-height:150%">
                    <span style="line-height:150%;">2024年7月8日</span>
                </p>
            </td>
        </tr>
        <tr>
            <td width="189" valign="top" style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
                <p style="text-indent:28px;text-align:center;line-height:150%">
                    <span style="line-height:150%;"><span>小低组（1-3年级）
                </p>
            </td>
            <td width="189" valign="top" style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
                <p style="text-indent:28px;text-align:center;line-height:150%">
                    <span style="line-height:150%;">9:30-10:30</span>
                </p>
            </td>
            <td width="189" valign="top" style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
                <p style="text-indent:28px;text-align:center;line-height:150%">
                    <span style="line-height:150%;">9:30-10:30</span>
                </p>
            </td>
        </tr>
        <tr>
            <td width="189" valign="top" style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
                <p style="text-indent:28px;text-align:center;line-height:150%">
                    <span style="line-height:150%;"><span>小高组（4-6年级）
                </p>
            </td>
            <td width="189" valign="top" style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
                <p style="text-indent:28px;text-align:center;line-height:150%">
                    <span style="line-height:150%;">13:30-14:30</span>
                </p>
            </td>
            <td width="189" valign="top" style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
                <p style="text-indent:28px;text-align:center;line-height:150%">
                    <span style="line-height:150%;">13:30-14:30</span>
                </p>
            </td>
        </tr>
        <tr>
            <td width="189" valign="top" style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
                <p style="text-indent:28px;text-align:center;line-height:150%">
                    <span style="line-height:150%;">初中组</span>
                </p>
            </td>
            <td width="189" valign="top" style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
                <p style="text-indent:28px;text-align:center;line-height:150%">
                    <span style="line-height:150%;">15:00-16:00</span>
                </p>
            </td>
            <td width="189" valign="top" style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
                <p style="text-indent:28px;text-align:center;line-height:150%">
                    <span style="line-height:150%;">15:00-16:00</span>
                </p>
            </td>
        </tr>
    </tbody>
</table>
<p style="text-indent:28px;line-height:150%">
    <span style="line-height:150%;">【活动地点】：北京朝来农艺园</span>
</p>
<p style="text-indent:28px;line-height:150%">
    <span style="line-height:150%;">【活动亮点】：</span>
</p>
<p style="text-indent:28px;line-height:150%">
    <span style="line-height:150%;">1.前沿科技——数智农场黑科技大揭秘</span>
</p>
<p style="text-indent:28px;line-height:150%">
    <img width="522" src="${require("../../assets/custom/clnyy/dataImgs/wz-2-1.png")}">
</p>
<p style="text-indent:28px;line-height:150%">
    <span style="line-height:150%;">2.种植魔法——多种栽培技术应用实例</span>
</p>
<p style="text-indent:63px;line-height:150%">
        <img width="522" src="${require("../../assets/custom/clnyy/dataImgs/wz-2-2.png")}">
</p>
<p style="text-indent:28px;line-height:150%">
    <span style="line-height:150%;">3.蔬香四溢——多品类农作物观览识别</span>
</p>
<p style="text-indent:28px;line-height:150%">
     <img width="522" src="${require("../../assets/custom/clnyy/dataImgs/wz-2-3.png")}">
</p>
<p style="text-indent:28px;line-height:150%">
    <span style="line-height:150%;">【注意事项】：</span>
</p>
<p style="text-indent:28px;line-height:150%">
    <span style="line-height:150%;">1、因不同组别参观讲授内容不同，请已报名的学生根据报名时选择的时间前往参观</span>
</p>
<p style="text-indent:28px;line-height:150%">
    <span style="line-height:150%;">2、参观当天，请穿着舒适的休闲装与运动鞋，携带个人水杯。</span>
</p>
<p style="text-indent:28px;line-height:150%">
    <span style="line-height:150%;">3、为确保安全，请遵守农场的各项规定，听从工作人员引导。</span>
</p>
<p style="text-indent:28px;line-height:150%">
    <span style="line-height:150%;">4、园区配有家长休息室，学生参观时家长可在休息室等候。</span>
</p>
<p style="text-indent:28px;line-height:150%">
    <span style="line-height:150%;">5、如遇特殊天气，活动将顺延，具体安排将以短信或电话形式通知。</span>
</p>
<p style="text-indent:28px;line-height:150%">
    <span style="line-height:150%;">&nbsp;</span>
</p>
<p style="text-indent:28px;line-height:150%">
    <span style="line-height:150%;">我们相信，这次智慧农场的探索之旅，不仅能让学生们学到丰富的农业知识，更能激发他们对科学探索的热情。期待各位的热情参与，共同开启智慧农业的奇妙旅程！</span>
</p>
<p style="text-indent:28px;line-height:150%">
    <span style="line-height:150%;">敬请转发周知，让更多学生伙伴共享这份精彩！</span>
</p>
<p>
    <span>&nbsp;</span>
</p>
<p style="text-align:right">
    <span>“智慧农业杯”科普活动组委会</span>
</p>
<p style="text-align:right">
    <span>2024年6月10日</span>
</p>
        `
  },
  {
    id: "4", name: "2024年朝阳区中小学生“智慧农业杯”科普行动初选通知",
    html: `
      <p>为充分发挥地区专业科普资源，促进中小学生对智慧农业的进一步认识，激发学生对于农业科学的兴趣和实际动手能力，北京市朝阳区农业农村局、北京市朝阳区来广营乡人民政府联合北京市朝阳区科学技术协会，依托朝来农艺园国家数字农业创新应用基地，举办朝阳区中小学生“智慧农业杯”科普活动。活动分为初选、复选、总决选及线下体验活动，现将初选流程及方式通知如下：
        </p>
        <p><b>初选时间：</b><span>7月9日-7月11日</span></p>
        <p><b>初选方式：</b><span>线上答题。学生可在比赛时间内随时登录网站初选，分组进行。每组选手均同时间段线上作答，每场时间不超过30分钟。只有一次答题机会。</span></p>
        <p><b>组别设置：</b><span>小学低年级组（1-3年级）；小学高年级组（4-6年级）组；初中组。</span></p>
        <p><b>初选流程：</b></p>
        <p>1.支持手机端和电脑端进行答题，可以通过访问链接或者扫描二维码进入平台【请注意，不同组别答题二维码不同】</p>
        <p>2.起止日期为7月9日0:00-7月11日0:00，才能进入答题页面，限制30分钟内作答完成，超时平台将强制交卷。只有一次答题机会。</p>
        <p>3.登录方式：通过报名时预留的手机号+验证码登录，<b>账号登陆方式无效</b>。</p>
        <p><img loading="lazy" src="${require("../../assets/custom/clnyy/dataImgs/wz-4-1.png")}" /></p>
        <p>3.答题平台链接：</p>
        <p>①小低组（1-3年级）链接及二维码：</p>
        <p><a href="https://www.qingsuyun.com/h5/166746/18081728290/" target="_blank">https://www.qingsuyun.com/h5/166746/18081728290/</a></p>
        <p><img loading="lazy" src="${require("../../assets/custom/clnyy/dataImgs/wz-4-2.png")}" /></p>
        <p>②小高组（4-6年级）链接及二维码：</p>
        <p><a href="https://www.qingsuyun.com/h5/166746/18081728302/" target="_blank">https://www.qingsuyun.com/h5/166746/18081728302/</a></p>
        <p><img loading="lazy" src="${require("../../assets/custom/clnyy/dataImgs/wz-4-3.png")}" /></p>
        <p>③初中组链接及二维码：</p>
        <p><a href="https://www.qingsuyun.com/h5/166746/18081728306/" target="_blank">https://www.qingsuyun.com/h5/166746/18081728306/</a></p>
        <p><img loading="lazy" src="${require("../../assets/custom/clnyy/dataImgs/wz-4-4.png")}" /></p>
        <p><br /></p>
        <p style="text-align:right;">“智慧农业杯”科普活动组委会</p>
        <p style="text-align:right;">2024年7月5日</p>
      `
  },
  {
    id: 5, name: "2024年朝阳区中小学生“智慧农业杯”科普活动智慧农业体验日邀请通知",
    html: `
        <p>为了激发广大中小学生对农业科技的兴趣，促进中小学生对智慧农业的进一步认识，丰富学生的实践体验，“智慧农业杯”科普活动组委会继科普参观活动后又迎来了智慧农业体验日活动，诚挚邀请朝阳区中小学学生来园体验。</p>
        <p>【活动主题】：智慧农业科普体验日</p>
        <p>【活动对象】：中小学生</p>
        <p>【组织形式】：分组体验</p>
        <p>【活动时间】：</p>
        <table>
            <tr>
                <td>组别</td>
                <td>7月13日（周六）</td>
                <td>7月14日（周日）</td>
            </tr>
            <tr>
                 <td>小低组<br/>（1-3年级）</td>
                 <td>8:30-10:00<br/>创意生态瓶<br/>农事体验-生菜采摘</td>
                 <td>8:30-10:00<br/>蔬菜大作战<br/>农事体验-生菜采摘</td>
            </tr>
            <tr>
                 <td>小高组<br/>（4-6年级）</td>
                 <td>10:30-12:00<br/>灌溉系统、过滤水装置<br/>农事体验-玉米采摘</td>
                 <td>10:30-12:00<br/>昆虫屋<br/>农事体验-玉米采摘</td>
            </tr>
            <tr>
                 <td>初中组</td>
                 <td>13:30-15:00<br/>温室搭建<br/>农事体验-玉米采摘</td>
                 <td></td>
            </tr>
        </table>
        <p>【活动地点】：北京朝来农艺园</p>
        <p>【活动内容】：</p>
        <p>一、未来农业体验——学习现代农业知识为主线，农业过程亲身体验</p>
        <p><b>1、《创意生态瓶》</b></p>
        <p class='imgGroup'><img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-5-1.png")}"/><img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-5-2.png")}"/></p>
        <p><b>2、《蔬菜大作战》</b></p>
        <p class='imgGroup'><img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-5-3.png")}"/><img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-5-4.png")}"/></p>
        <p><br /></p>
        
        <p>二、农业科学与环保——了解可持续农业生产模式。</p>
        <p><b>3、《灌溉系统、过滤水装置》</b></p>
        <p class='imgGroup'><img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-5-5.png")}"/><img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-5-6.png")}"/></p>
        <p><b>4、《昆虫屋》</b></p>
        <p class='imgGroup'><img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-5-7.png")}"/><img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-5-8.png")}"/></p>

        <p>三、创新科技活动——智能化设备体验，任务驱动下解决问题。</p>
        <p><b>5、《温室搭建》</b></p>
        <p class='imgGroup'><img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-5-9.png")}"/><img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-5-10.png")}"/></p>

        <p><b>6、农事体验活动——生菜采摘/玉米采摘</b></p>
        <p class='imgGroup'><img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-5-11.png")}"/><img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-5-12.png")}"/></p>
        <p class='imgGroup'><img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-5-13.png")}"/><img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-5-14.png")}"/></p>
        
        <p>【注意事项】：</p>
        <p>1、因不同组别体验讲授内容不同，请已报名的学生根据报名时选择的时间前往体验。</p>
        <p>2、参观当天，请穿着舒适的休闲装与运动鞋，携带个人水杯。</p>
        <p>3、为确保安全，请遵守农场的各项规定，听从工作人员引导。</p>
        <p>4、园区配有家长休息区，学生参观时家长可在休息区等候。</p>
        <p>5、活动当天农场办公区不设置停车位，请提前解决出行交通问题。</p> 
        <p>6、如遇特殊天气，活动将顺延，具体安排将以短信或电话形式通知。</p>
        <p>我们相信，这次智慧农业科普体验之旅，不仅能让学生们在多重感官刺激下感受智慧农业魅力，了解现代化农业⽣产流程，更能提高综合素质，激发他们对科学创新和探索求知精神的热情。期待各位的热情参与，共同开启智慧农业的奇妙旅程！</p>
        <p>敬请转发周知，让更多学生伙伴共享这份精彩！</p>
        <p style="margin-top:20px;text-align:right;">“智慧农业杯”科普活动组委会</p>
        <p style="text-align:right;">2024年7月11日</p>
        `
  },
  {
    id: 6, name: "“智慧农业杯”科普活动复选通知",
    html: `
        <p>经过初步的筛选和评审，“2024智慧农业杯”朝阳区中小学生农业科普活动的复选名单已经确定！恭喜所有入选的参选者，你们的努力和才华得到了认可。</p>
        <p><b>晋级名单：</b>详见附件1</p>
        <p><b>复选方式：</b>线上参选。学生根据随机配发主题（详见附件2），录制6-8分钟讲解视频，在7月15日-8月24日上传至ZHNYBkphd2024@163.com邮箱，邮件主题为姓名+题目，例如：张三 小低组主题一：智慧农场概述。</p>
        <p><b>参选活动规则：</b>（1）参选视频包含时长不超过1分钟的参选者自我介绍。包括个人介绍、兴趣爱好以及参加比选的缘由和期望等内容；</p>
        <p>（2）针对所选主题，清晰地进行介绍，包括但不限于农作物知识、智慧农业相关技术、应用案例以及对农业和社会的潜在影响等；</p>
        <p>（3）自身愿景：对智慧农业发展的想法与倡议。</p>
        <p><b>参选视频要求：</b></p>
        <p>（1）视频内容应具备逻辑性和条理性，能够深入浅出地介绍主题相关信息，清晰地表达自己的观点和想法；</p>
        <p>（2）参选者可自选使用适当的视觉辅助工具（如图表、图片、视频片段），以增强知识的展示和观者的兴趣；</p>
        <p>（3）视频大小与清晰度的要求：视频接受MP4格式，视频分辨率至少为1080P，文件压缩后大小不超过 1GB。</p>
        <p><b>评价标准：</b></p>
        <p>（1）所有参选者需在规定参选时间时提交视频材料，并确保视频质量和内容的完整性，符合内容要求与视频要求；</p>
        <p>（2）评分重点：参选选手的表达能力与对主题内容讲解的准确性、全面性、逻辑性；</p>
        <p>（3）评分兼顾考察视频的创新性、视觉效果以及视频的整体质量。</p>
        <p><b>复选支持：</b></p>
        <p>（1）2024年7月15日开放在线学习课程资源库平台，以帮助大家更好地准备复选。资源库地址：<a href="https://xuexi.jiaoyu.cn/center/100044/user/myClass" target="_blank">https://xuexi.jiaoyu.cn/center/100044/user/myClass</a>，使用报名手机号登陆，默认密码为：Ab123456。</p>
        <p>（2）7月15日-8月24日开放农场预约，为复选学生提供场地及讲解支持。
我们期待在复选中见到各位精彩的表现，祝大家好运！</p>
<p style="text-align:right;margin-top:20px;">“智慧农业杯”科普活动组委会</p>
<p style="text-align:right;padding-right:40px;">2024年7月15日</p>
<p><br /></p>
<p><br /></p>
<p><b>附件 1：</b></p>
<p style="text-indent:4rem;">题库主题（各主题下内容为参考，具体讲解内容可自行设计）</p>
<p style="text-indent:4rem;">小低年级</p>
<p style="text-indent:4rem;">主题一：智慧农场概述</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;什么是智慧农场？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;智慧农场与传统农场有什么不同？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;智慧农场的主要技术有哪些？</p>
<p style="text-indent:4rem;">主题二：农作物种植与生活</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;农作物种植的选取与注意事项；</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;无土栽培的种植方法与各自特点；</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;农作物田间管理要素与对应设施农业解决办法。</p>
<p style="text-indent:4rem;">主题三：无人机在农业中的应用</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;无人机在农业中的主要用途是什么？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;无人机如何进行农田监测？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;无人机的使用对农场管理有什么好处？</p>
<p style="text-indent:4rem;">主题四：农业传感器</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;农业传感器有哪些种类？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;这些传感器如何帮助监测土壤、空气和植物健康？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;使用传感器数据可以做出哪些决策？</p>
<p style="text-indent:4rem;">主题五：智能灌溉系统</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;什么是智能灌溉系统？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;智能灌溉系统如何节约用水？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;这种系统是如何根据天气和土壤湿度调整灌溉量的？</p>
<p style="text-indent:4rem;">小高年级</p>
<p style="text-indent:4rem;">主题一：智慧农场概述</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;什么是智慧农场？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;智慧农场与传统农场有什么不同？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;智慧农场的主要技术有哪些？</p>
<p style="text-indent:4rem;">主题二：温室自动化</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;什么是温室自动化？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;温室自动化系统包括哪些主要设备？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;自动化温室如何控制温度、湿度和光照？</p>
<p style="text-indent:4rem;">主题三：机器人在农业中的应用</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;哪些农业工作可以由机器人完成？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;农业机器人如何进行种植、施肥和收割？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;机器人在农业中应用的优势是什么？</p>
<p style="text-indent:4rem;">主题四：设施农业的特性</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;什么是设施农业？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;设施农业的核心技术是什么？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;举例说明设施农业是如何影响农作物生长的。</p>
<p style="text-indent:4rem;">主题五：无人机在农业中的应用</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;无人机在农业中的主要用途是什么？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;无人机如何进行农田监测？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;无人机的使用对农场管理有什么好处？</p>
<p style="text-indent:4rem;"><br /></p>
<p style="text-indent:4rem;">初中年级</p>
<p style="text-indent:4rem;">主题一：智慧农场概述</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;什么是智慧农场？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;智慧农场与传统农场有什么不同？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;智慧农场的主要技术有哪些？</p>
<p style="text-indent:4rem;">主题二：物联网（IoT）在农业中的应用</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;什么是物联网？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;智慧农场中有哪些设备使用了物联网技术？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;物联网技术如何帮助农民管理农场？</p>
<p style="text-indent:4rem;">主题三：精准农业</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;什么是精准农业？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;精准农业的主要工具和技术有哪些？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;精准农业如何提高产量和减少资源浪费？</p>
<p style="text-indent:4rem;">主题四：大数据与农业</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;什么是农业大数据？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;大数据在农业决策中起了什么作用？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;农业大数据如何预测病虫害和天气变化？</p>
<p style="text-indent:4rem;">主题五：智慧农场的环境影响与可持续性发展</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;智慧农场如何减少环境污染？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;智慧农场在可持续农业中的作用是什么？</p>
<p style="text-indent:4rem;">•&nbsp;&nbsp;&nbsp;&nbsp;环保技术在智慧农场中的应用有哪些？</p>
<p><br /></p>
<p><b>附件 2：</b></p>
<table style="margin-bottom:30px;">
    <thead>
        <th colspan="3">
            2024“智慧农业杯”科普活动<br />
            复选名单-小低组（1-3年级）排名不分先后
        </th>
    </thead>
    <tbody>
        <tr>
            <td style="font-weight:bold;">序号</td>
            <td style="font-weight:bold;">姓名：</td>
            <td style="font-weight:bold;">手机号码</td>
        </tr>
    <tr>
      <td>1</td>
      <td>吴一凡</td>
      <td>186****5286</td>
    </tr>
    <tr>
      <td>2</td>
      <td>王艺潼</td>
      <td>135****2658</td>
    </tr>
    <tr>
      <td>3</td>
      <td>邵鸣谦</td>
      <td>186****0995</td>
    </tr>
    <tr>
      <td>4</td>
      <td>李若溪</td>
      <td>186****6104</td>
    </tr>
    <tr>
      <td>5</td>
      <td>李浩楠</td>
      <td>136****2533</td>
    </tr>
    <tr>
      <td>6</td>
      <td>汤沐阳</td>
      <td>189****6919</td>
    </tr>
    <tr>
      <td>7</td>
      <td>胡庭语</td>
      <td>138****6988</td>
    </tr>
    <tr>
      <td>8</td>
      <td>周一凡</td>
      <td>138****7307</td>
    </tr>
    <tr>
      <td>9</td>
      <td>赵宇浠</td>
      <td>139****2745</td>
    </tr>
    <tr>
      <td>10</td>
      <td>赵泓喻</td>
      <td>185****6037</td>
    </tr>
    <tr>
      <td>11</td>
      <td>王逸宸</td>
      <td>136****9794</td>
    </tr>
    <tr>
      <td>12</td>
      <td>孙奕葭</td>
      <td>182****1323</td>
    </tr>
    <tr>
      <td>13</td>
      <td>彭玥童</td>
      <td>137****0822</td>
    </tr>
    <tr>
      <td>14</td>
      <td>刘聿修</td>
      <td>138****6920</td>
    </tr>
    <tr>
      <td>15</td>
      <td>郝家琪</td>
      <td>138****6723</td>
    </tr>
    <tr>
      <td>16</td>
      <td>赵梓涵</td>
      <td>150****0805</td>
    </tr>
    <tr>
      <td>17</td>
      <td>张钧源</td>
      <td>138****1773</td>
    </tr>
    <tr>
      <td>18</td>
      <td>徐晨赫</td>
      <td>187****3569</td>
    </tr>
    <tr>
      <td>19</td>
      <td>王奕童</td>
      <td>186****8226</td>
    </tr>
    <tr>
      <td>20</td>
      <td>王沐泽</td>
      <td>138****0002</td>
    </tr>
    <tr>
      <td>21</td>
      <td>李天煜</td>
      <td>186****5605</td>
    </tr>
    <tr>
      <td>22</td>
      <td>邓天润</td>
      <td>133****3205</td>
    </tr>
    <tr>
      <td>23</td>
      <td>邓芃墨</td>
      <td>186****5907</td>
    </tr>
    <tr>
      <td>24</td>
      <td>白梓彤</td>
      <td>186****6015</td>
    </tr>
    <tr>
      <td>25</td>
      <td>杨隽艺</td>
      <td>138****2524</td>
    </tr>
    <tr>
      <td>26</td>
      <td>王若涵</td>
      <td>185****7953</td>
    </tr>
    <tr>
      <td>27</td>
      <td>孟宪怡</td>
      <td>138****1448</td>
    </tr>
    <tr>
      <td>28</td>
      <td>刘宣妍</td>
      <td>135****6818</td>
    </tr>
    <tr>
      <td>29</td>
      <td>雷昊霖</td>
      <td>152****4181</td>
    </tr>
    <tr>
      <td>30</td>
      <td>胡庭妍</td>
      <td>139****7598</td>
    </tr>
    <tr>
      <td>31</td>
      <td>禾津豪</td>
      <td>133****7266</td>
    </tr>
     <tr>
      <td>32</td>
      <td>赵允妍</td>
      <td>156****2896</td>
    </tr>
    <tr>
      <td>33</td>
      <td>张芷萌</td>
      <td>134****4821</td>
    </tr>
    <tr>
      <td>34</td>
      <td>袁昊</td>
      <td>136****2059</td>
    </tr>
    <tr>
      <td>35</td>
      <td>曲奕璇</td>
      <td>188****2717</td>
    </tr>
    <tr>
      <td>36</td>
      <td>刘正阳</td>
      <td>158****4665</td>
    </tr>
    <tr>
      <td>37</td>
      <td>陈秋宇</td>
      <td>186****1945</td>
    </tr>
    <tr>
      <td>38</td>
      <td>蔡艺洋</td>
      <td>186****1300</td>
    </tr>
    <tr>
      <td>39</td>
      <td>毕歌媛</td>
      <td>186****6336</td>
    </tr>
        <tr>
      <td>40</td>
      <td>鲁夏彤</td>
      <td>159****5536</td>
    </tr>
    <tr>
      <td>41</td>
      <td>李堂瑞</td>
      <td>185****2011</td>
    </tr>
    <tr>
      <td>42</td>
      <td>李牧远</td>
      <td>134****2022</td>
    </tr>
    <tr>
      <td>43</td>
      <td>胡周舒潼</td>
      <td>138****9927</td>
    </tr>
    <tr>
      <td>44</td>
      <td>谭雪怡</td>
      <td>136****7456</td>
    </tr>
    <tr>
      <td>45</td>
      <td>孙青宇</td>
      <td>131****9778</td>
    </tr>
    <tr>
      <td>46</td>
      <td>谯楚</td>
      <td>139****2095</td>
    </tr>
    <tr>
      <td>47</td>
      <td>林奕阳</td>
      <td>152****2549</td>
    </tr>
    <tr>
      <td>48</td>
      <td>侃侃</td>
      <td>158****5542</td>
    </tr>
    <tr>
      <td>49</td>
      <td>于嵩航</td>
      <td>185****3700</td>
    </tr>
    <tr>
      <td>50</td>
      <td>王若涵</td>
      <td>189****8521</td>
    </tr>
    <tr>
      <td>51</td>
      <td>燕祉伊</td>
      <td>136****8298</td>
    </tr>
    <tr>
      <td>52</td>
      <td>肖子熙</td>
      <td>159****5311</td>
    </tr>
    <tr>
      <td>53</td>
      <td>刘一诺</td>
      <td>139****8690</td>
    </tr>
    <tr>
      <td>54</td>
      <td>宗熠</td>
      <td>133****0009</td>
    </tr>
    <tr>
      <td>55</td>
      <td>张珺伊</td>
      <td>159****8219</td>
    </tr>
    </tbody>
</table>


<table style="margin-bottom:30px;">
    <thead>
        <th colspan="3">
            2024“智慧农业杯”科普活动<br />
            复选名单-小高组（4-6年级）排名不分先后
        </th>
    </thead>
    <tbody>
        <tr>
            <td style="font-weight:bold;">序号</td>
            <td style="font-weight:bold;">姓名：</td>
            <td style="font-weight:bold;">手机号码</td>
        </tr>
            <tr>
      <td>1</td>
      <td>高晟轩</td>
      <td>159****6687</td>
    </tr>
    <tr>
      <td>2</td>
      <td>吴浩然</td>
      <td>130****8666</td>
    </tr>
    <tr>
      <td>3</td>
      <td>魏辰</td>
      <td>186****8189</td>
    </tr>
    <tr>
      <td>4</td>
      <td>沈超然</td>
      <td>136****3435</td>
    </tr>
    <tr>
      <td>5</td>
      <td>刘赫奕</td>
      <td>186****4895</td>
    </tr>
    <tr>
      <td>6</td>
      <td>姜晓荷</td>
      <td>158****3943</td>
    </tr>
    <tr>
      <td>7</td>
      <td>张靖遥</td>
      <td>138****1697</td>
    </tr>
    <tr>
      <td>8</td>
      <td>孙中享</td>
      <td>186****0793</td>
    </tr>
    <tr>
      <td>9</td>
      <td>李俊逸</td>
      <td>186****0132</td>
    </tr>
    <tr>
      <td>10</td>
      <td>房旭佳</td>
      <td>186****1008</td>
    </tr>
    <tr>
      <td>11</td>
      <td>张景元</td>
      <td>186****6057</td>
    </tr>
    <tr>
      <td>12</td>
      <td>尹芷凡</td>
      <td>134****9669</td>
    </tr>
    <tr>
      <td>13</td>
      <td>任梓菡</td>
      <td>139****7728</td>
    </tr>
    <tr>
      <td>14</td>
      <td>嵇沐</td>
      <td>134****1410</td>
    </tr>
    <tr>
      <td>15</td>
      <td>郭浩天</td>
      <td>137****4039</td>
    </tr>
    <tr>
      <td>16</td>
      <td>耿梓清</td>
      <td>186****3588</td>
    </tr>
    <tr>
      <td>17</td>
      <td>马欣妍</td>
      <td>135****5541</td>
    </tr>
    <tr>
      <td>18</td>
      <td>马唯轩</td>
      <td>139****6184</td>
    </tr>
    <tr>
      <td>19</td>
      <td>季则翰</td>
      <td>186****6805</td>
    </tr>
    <tr>
      <td>20</td>
      <td>张巧晨</td>
      <td>150****9036</td>
    </tr>
    <tr>
      <td>21</td>
      <td>李奕楠</td>
      <td>137****0476</td>
    </tr>
    <tr>
      <td>22</td>
      <td>李若卿</td>
      <td>138****4959</td>
    </tr>
    <tr>
      <td>23</td>
      <td>邓钤予</td>
      <td>136****7325</td>
    </tr>
    <tr>
      <td>24</td>
      <td>赵思默</td>
      <td>158****0454</td>
    </tr>
    <tr>
      <td>25</td>
      <td>杨诗淇</td>
      <td>132****5455</td>
    </tr>
    <tr>
      <td>26</td>
      <td>王紫雯</td>
      <td>157****1757</td>
    </tr>
    <tr>
      <td>27</td>
      <td>王俊尧</td>
      <td>138****4894</td>
    </tr>
    <tr>
      <td>28</td>
      <td>郭思天</td>
      <td>152****3285</td>
    </tr>
    <tr>
      <td>29</td>
      <td>颜珈禾</td>
      <td>139****6373</td>
    </tr>
    <tr>
      <td>30</td>
      <td>汪子夜</td>
      <td>131****7083</td>
    </tr>
    <tr>
      <td>31</td>
      <td>嵇沐</td>
      <td>138****6870</td>
    </tr>
    <tr>
      <td>32</td>
      <td>高远航</td>
      <td>132****3112</td>
    </tr>
    <tr>
      <td>33</td>
      <td>柴睿</td>
      <td>131****7499</td>
    </tr>
      <tr>
      <td>34</td>
      <td>刘歆然</td>
      <td>186****1312</td>
    </tr>
    <tr>
      <td>35</td>
      <td>杨安然</td>
      <td>150****2852</td>
    </tr>
    <tr>
      <td>36</td>
      <td>王紫霏</td>
      <td>157****7665</td>
    </tr>
    <tr>
      <td>37</td>
      <td>董清璇</td>
      <td>186****3631</td>
    </tr>
    <tr>
      <td>38</td>
      <td>徐靖斐</td>
      <td>136****9969</td>
    </tr>
    <tr>
      <td>39</td>
      <td>谭莉霏</td>
      <td>186****7016</td>
    </tr>
    <tr>
      <td>40</td>
      <td>洪浩宸</td>
      <td>138****6717</td>
    </tr>
    <tr>
      <td>41</td>
      <td>高梓媗</td>
      <td>186****2998</td>
    </tr>
    <tr>
      <td>42</td>
      <td>崔田田</td>
      <td>187****8007</td>
    </tr>
    <tr>
      <td>43</td>
      <td>胡淑雅</td>
      <td>185****8706</td>
    </tr>
    <tr>
      <td>44</td>
      <td>王先珩</td>
      <td>138****2301</td>
    </tr>
    <tr>
      <td>45</td>
      <td>刘子菡</td>
      <td>135****8137</td>
    </tr>
    <tr>
      <td>46</td>
      <td>陈思源</td>
      <td>138****5851</td>
    </tr>
    <tr>
      <td>47</td>
      <td>高圣乾</td>
      <td>138****4758</td>
    </tr>
    <tr>
      <td>48</td>
      <td>柴睿</td>
      <td>131****6686</td>
    </tr>
    <tr>
      <td>49</td>
      <td>毕芃特</td>
      <td>158****6973</td>
    </tr>
    <tr>
      <td>50</td>
      <td>邹小稳</td>
      <td>138****6926</td>
    </tr>
    <tr>
      <td>51</td>
      <td>袁晨</td>
      <td>138****3477</td>
    </tr>
    
    </tbody>
</table>




<table>
    <thead>
        <th colspan="3">
            2024“智慧农业杯”科普活动<br />
            复选名单-初中组（排名不分先后）
        </th>
    </thead>
    <tbody>
    <tr>
            <td style="font-weight:bold;">序号</td>
            <td style="font-weight:bold;">姓名：</td>
            <td style="font-weight:bold;">手机号码</td>
        </tr>
        <tr>
      <td>1</td>
      <td>熊圃笙</td>
      <td>159****1227</td>
    </tr>
    <tr>
      <td>2</td>
      <td>周彧悦</td>
      <td>135****8317</td>
    </tr>
    <tr>
      <td>3</td>
      <td>张景胤</td>
      <td>186****2757</td>
    </tr>
    <tr>
      <td>4</td>
      <td>李语涵</td>
      <td>135****4330</td>
    </tr>
    <tr>
      <td>5</td>
      <td>廖浩岚</td>
      <td>139****4195</td>
    </tr>
    <tr>
      <td>6</td>
      <td>李诗祺</td>
      <td>159****9640</td>
    </tr>
    <tr>
      <td>7</td>
      <td>谢思聪</td>
      <td>186****9769</td>
    </tr>
    <tr>
      <td>8</td>
      <td>蔡孟珍</td>
      <td>185****3215</td>
    </tr>
    <tr>
      <td>9</td>
      <td>王疆然</td>
      <td>15652012258</td>
    </tr>
    <tr>
      <td>10</td>
      <td>鲁诚傲</td>
      <td>13466705292</td>
    </tr>
    </tbody>
</table>


 `
  },
  {
    id: 9, name: "“智慧农业杯”科普活动场地开放预约通知", html: `
    <p>为了给复赛学生提供专业指导、资源获取，以及展示才能的舞台，北京朝来农艺园现在面向所有复赛选手开放预约，预约方式如下：</p>
    <p><b>预约时间：8月12上午8:30-12:00</b></p>
    <p style="text-indent:6.1rem;"><b>8月19上午8:30-12:00</b></p>
    <p><b>预约方式：</b></p>
    <p>请打开报名链接：<a target="_blank" href="https://www.wjx.top/vm/YXYSkrk.aspx#">https://www.wjx.top/vm/YXYSkrk.aspx#</a></p>
    <p>或扫描以下二维码，填写预约表格，并选择您偏好的时间段。</p>
    <p style="margin:20px 0;"><img src="${require("../../assets/custom/clnyy/dataImgs/wz-9-1.png")}"/></p>
    <p>智慧农业杯希望能够为复赛学生提供全面支持的环境，不再受限于个人空间的局限，最大化地激发学生的潜能，深化理解。由农场专家或资深教师提供专业的指导，不仅能够填补知识的空白，更能在关键时刻给予策略性的建议，帮助学生优化准备方案，以最佳状态迎接比赛的考验。不要错过这个宝贵机会，立即预约您的专属时段。</p>
    `},
  {
    id: 10, name: "“智慧农业部”科普活动总决选直播通知", html: `
      <p>“智慧农业杯”科普活动经过初选及复选环节，即将迎来最激动人心的时刻——总决选阶段。为了让更多的学生、家长能够参与到这一盛事之中，总决选阶段将开放现场直播。现将有关事项通知如下：</p>
      <p>直播时间：2024年9月20日（星期五）9:20开始，全程直播</p>
      <p><b>观看方式：请微信扫描如下二维码进行观看</b></p>
      <p style="margin:15px 0;"><img src="${require("../../assets/custom/clnyy/dataImgs/wz-10-1.png")}" /></p>
      <p>我们希望通过这次直播，让更多的人关注和支持智慧农业的发展，同时也为参赛选手提供一个展示才华的平台。期待您的参与！</p>
      <p>特此通知。</p>
      <p style="text-align:right;">
        “智慧农业杯”科普活动组委会
        <br />
        2024年9月19日
      </p>
      `
  }

]

// 活动报道数据
const hdbdData = [
  {
    id: 3, name: "【智慧农业杯】探索未来农田，2024年朝阳区中小学生“智慧农业杯”科普活动精彩回顾",
    html: `
<p>
    <strong><span><span>【活动现场直击】</strong>
</p>
<p>
    在2024年6月22日，在这个被夏日阳光轻柔拥抱的6月天，由北京市朝阳区农业农村局、<span style="color:#2C2C36;;background:#FFFFFF"><span>北京市<span>朝阳区来广营乡人民政府主办，北京市朝阳区科学技术协会指导的</span><span style="color:#2C2C36;;background:#FFFFFF"><span>2024年朝阳区中小学生“智慧农业杯”科普活动第一次线下活动在北京朝来农艺园召开啦！
</p>
<p>
    参加“智慧农业杯”科普知识竞赛的小朋友们齐聚一堂，共同探索智慧农业的奥秘。
</p>
<p style="height:10px;"></p>
<p style="text-align:center;">
    <img style="display:inline;"  width="238" height="175" src="${require("../custom/clnyy/dataImgs/wz-3-1.jpg")}"/>
    &nbsp;&nbsp;&nbsp;
    <img style="display:inline;"  width="238" height="175" src="${require("../custom/clnyy/dataImgs/wz-3-2.jpg")}"/>
</p>

<p style="height:10px;"></p>
<p>
    <strong><span><span>【科普之旅启航】</strong>
</p>
<p>
    <span>什么是智慧农业？它与传统农业的区别的什么？</span>
</p>
<p>
    <span>什么又是水培技术？没有土壤的无土化栽培如何让植物茁壮成长的？</span>
</p>
<p>
    <span>现代信息技术是如何应用到农业领域的？</span>
</p>
<p>
<span>带着这些疑问孩子们跟随我们的老师开启了一场“科技农场大揭秘”之旅。</span>
</p>
<p style="height:10px;"></p>
<p style="text-align:center;">
 <img style="display:inline;" width="238" height="175" src="${require("../custom/clnyy/dataImgs/wz-3-3.jpg")}"/>
 &nbsp;&nbsp;&nbsp;
  <img style="display:inline;" width="239" height="175" src="${require("../custom/clnyy/dataImgs/wz-3-4.jpg")}"/>
</p>


<p style="height:10px;"></p>

<p>
    <span style="color:#2C2C36;;background:#FFFFFF"><span><b>【智慧农业的魅力】</b>
</p>


<p>
    <span>在这里，智慧农业第一次以触手可及的具体形象展现在孩子们面前。实时反映农场数据的数据大屏，从自动播种、精准灌溉到病虫害智能监测的智能机器人，每一环节都将科技的智慧展现得淋漓尽致。孩子们亲眼见了证科技如何让农业变得更加高效、环保。</span>
</p>
<p style="height:10px;"></p>
<p style="text-align:center;">
 <img style="display:inline;"  width="238" height="175" src="${require("../custom/clnyy/dataImgs/wz-3-5.jpg")}"/>
</p>
<p style="height:10px;"></p>

<p>
    <span>想象一下，植物无需泥土也能茁壮成长！在我们的无土栽培区，孩子们将亲手触摸水培、气培等现代化种植技术，学习如何在纯净的营养液中培育出鲜嫩欲滴的蔬菜和水果，体验未来食物生产的新模式。</span>
</p>
<p style="height:10px;"></p>

<p style="text-align:center;">
 <img  style="display:inline;"  width="238" height="175" src="${require("../custom/clnyy/dataImgs/wz-3-6.jpg")}"/>
</p>
<p style="height:10px;"></p>


<p>
    走进全自动化温室，感受四季如春的秘密。孩子们将通过互动体验，了解如何利用高科技温控系统调节温度、湿度和光照，创造出最适合植物生长的微环境。在这里，每一株植物都生活在“定制”的环境中，展示了人类智慧与自然法则的完美结合。
</p>
<p style="height:10px;"></p>
<p style="text-align:center;">
 <img  style="display:inline;"  width="238" height="175" src="${require("../custom/clnyy/dataImgs/wz-3-7.jpg")}"/>
</p>
<p style="height:10px;"></p>

<p>
    <span>孩子们在活动中展现出了对智慧农业的强烈好奇，认识到科技进步对现代农业的巨大影响。每一次亲身体验都是播种未来科学家梦想的种子，引导孩子们共同探索智慧农业的无限可能。</span>
</p>
<p style="height:10px;"></p>

<p style="text-align:center;">
 <img style="display:inline;"  width="238" height="175"  src="${require("../custom/clnyy/dataImgs/wz-3-8.jpg")}"/>
 &nbsp;&nbsp;&nbsp;
 <img style="display:inline;"  width="238" height="175"  src="${require("../custom/clnyy/dataImgs/wz-3-9.jpg")}"/>
</p>
<p style="height:10px;"></p>
<p>
    【下期预告】这个活动是不是很有趣？为了让更多学生了解现代农业的知识，感受智慧农业的魅力，我们还将于7月8日举办第二期线下参观讲解活动，欢迎各位中小学生热情参与。
</p>
<p>
    <span>【报名方式】：</span>
</p>
<p>
    <span>扫描下方二维码可直接进入报名页面</span>
</p>
<p style="text-align:center;">
    <img style="display:inline;" width="118" height="118" src="${require("../custom/clnyy/dataImgs/wz-3-10.png")}"/>

</p>
<p>
    <span>参赛学生作为农场的小小科普推广员，可申请志愿者时长哦。志愿项目二维码如下：</span>
</p>
<p style="text-align:center;">
        <img style="display:inline;" width="118" height="118" src="${require("../custom/clnyy/dataImgs/wz-3-11.png")}"/>
</p>
<p style="height:10px;"></p>
        `
  },
  {
    id: 7, name: "“智慧农业杯”科普活动开讲啦！", html: `
        <p>在这个科技飞速发展的时代，我们有幸见证并参与了一场农业革命。智慧农场，一个将传统农业与现代科技完美融合的产物，正在成为中小学教育的一股新鲜血液。在6月22日举办的第一场“智慧农业杯”科普活动余热未散之际，7月8日我们又迎来了更加精彩纷呈的新一轮科普活动，不仅在规模、内容上有所突破，更在参与度和影响力上达到了新的高度。本次朝来农艺园迎来了100余名不同年龄段的中小学生走进智慧农场的世界，感受它带来的科普魅力。</p>
         <p class="imgGroup moreLine">
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-1-1.jpg")}"/>
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-1-2.jpg")}"/>
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-1-3.jpg")}"/>
        </p>
         <p class="imgGroup moreLine">
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-1-4.jpg")}"/>
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-1-5.jpg")}"/>
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-1-6.jpg")}"/>
        </p>

        <p>活动开始，园区讲解员在科普展厅为同学们深入浅出讲解了智慧农场，从物联网、大数据、人工智能等先进技术，到农业生产的智能化和精细化。从土壤监测到作物生长分析，到智能灌溉到自动施肥，期间同学们展现了非凡的热情与求知欲，讲到关键处同学们纷纷举手，渴望分享自己的见解或是心中疑惑。</p>
         <p class="imgGroup moreLine">
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-2-1.jpg")}"/>
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-2-2.jpg")}"/>
        </p>
         <p class="imgGroup moreLine">
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-2-3.jpg")}"/>
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-2-4.jpg")}"/>
        </p>
        <p>智能农业设备：</p>
        <p>紧接着园区指导员带领学生进入温室大棚介绍各种智能农业设备，自动化灌溉系统、智能温室、农业机器人等，接触国产最前沿的农业科技。在真实农场环境中感受智能农业技术的实际应用效果，如作物生长监测、病虫害管理等。这些令人惊叹的技术不仅提高了农业的效率，也展示了未来农业的可能性。通过智慧农场的学习，或许就能在孩子们心中种下一颗科技农业的种子，激发他们成为下一代的农业科学家或创新者。</p>
 <p class="imgGroup moreLine">
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-3-1.jpg")}"/>
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-3-2.jpg")}"/>
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-3-3.jpg")}"/>
        </p>
         <p class="imgGroup moreLine">
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-3-4.jpg")}"/>
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-3-5.jpg")}"/>
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-3-6.jpg")}"/>
        </p>
        <p>可持续农业实践：</p>
        <p>智慧农场除了智能装备，更强调环保、资源节约和生态平衡的农业模式，如何通过智能技术实现可持续发展呢？无土化栽培技术、蔬菜水培技术、水循环智能控制这些概念在在园区指导员的实地参观和讲解下同学们无不感到新奇。</p>
         <p class="imgGroup moreLine">
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-4-1.jpg")}"/>
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-4-2.jpg")}"/>
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-4-3.jpg")}"/>
        </p>
         <p class="imgGroup moreLine">
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-4-4.jpg")}"/>
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-4-5.jpg")}"/>
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-4-6.jpg")}"/>
        </p>
        <p> 通过此次线下科普活动，同学们不仅普及了智慧农业科普知识，更希望通过创造性的科普活动，让学生了解乡村振兴战略的国家政策，认识智慧农业如何助力农村经济发展和社会进步，鼓励学生发挥创意，解决农业领域的实际问题。</p>
        <p>
          <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-7-5-1.jpg")}"/>
        </p>
        <p style="text-align:center;">7月13日、14日线下体验活动开放中，期待大家的参与！</p>
  `},
  {
    id: 8, name: "探索未来农田，2024 年朝阳区中小学生“智慧农业杯”线下科普体验活动精彩回顾 ", html: `
       <p>在这个充满创新与探索的夏季，备受瞩目的“智慧农业杯科普活动”复选阶段于7月13日至14日成功举办了一系列精彩纷呈的线下体验活动。此次活动旨在通过让学生亲身体验，深刻理解智慧农业的魅力，感受科技如何在田间地头书写绿色发展的新篇章。</p>
       <p class="imgGroup moreLine">
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-7-1.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-7-2.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-7-3.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-7-4.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-7-5.jpg")}"/>
       </p>
       <p>活动现场直击</p>
       <p>根据学生不同年龄阶段的特点，我们为不同组别的同学准备了各具特色的体验活动。</p>
       <p>小低组体验活动分别是多肉生态瓶和蔬菜水果沙拉。</p>
       <p>多肉生态瓶：同学们们利用各种小型植物、沙石和装饰物，创造出独一无二的生态瓶，每一个都是个性化的艺术品。通过实践操作，大家不仅学会了如何种植多肉植物，还了解了生态瓶内的小环境是如何维持平衡的。活 后，大家积极分享了自己的创作灵感和养护心得。</p>
       <p class="imgGroup moreLine">
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-1-1.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-1-2.jpg")}"/>
       </p>
        <p class="imgGroup moreLine">
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-1-3.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-1-4.jpg")}"/>
       </p>

       <p>蔬菜水果沙拉：活动前老师详细介绍了各种食材的营养价值，以及如何合理搭配食物来保持均衡饮食。后续同学们在老师的指导下，挑选新鲜的水果和蔬菜，亲手制作了一盘盘色彩斑斓的沙拉。</p>
        <p class="imgGroup moreLine">
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-2-1.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-2-2.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-2-3.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-2-4.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-2-5.jpg")}"/>
       </p>
       <p>小高组体验的是过滤水装置和小小建筑师——昆虫屋</p>
       <p>过滤水装置：同学们在老师的指导下，利用简单的材料如沙子、活性炭、棉花等，亲手搭建了一个个高效的过滤装置。活动过程中，老师详细介绍了水污染的危害以及如何通过过滤等技术净化水。同学们被鼓励记录过滤前后水质的变化，并通过观察和比较，学习到了环境保护的重要性。</p>
        <p class="imgGroup moreLine">
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-3-1.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-3-2.jpg")}"/>
       </p>
        <p class="imgGroup moreLine">
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-3-3.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-3-4.jpg")}"/>
       </p>
       <p>小小建筑师——昆虫屋</p>
       <p>同学们在老师带领下，在户外寻找、辨别吸引不同昆虫的植物，了解身边常见昆虫的种类、习性以及它们对环境的重要性。同学们热情高涨，不时围绕在老师身边展示自己发现的昆虫种类。后续利用废弃材料如木块、稻草和竹筒等，模拟搭建了一个个独特的昆虫屋。</p>
        <p class="imgGroup moreLine">
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-4-1.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-4-2.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-4-3.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-4-4.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-4-5.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-4-6.jpg")}"/>
       </p>
       <p>初中组的同学在初赛前参观了智能温室，在此次则进行了迷你温室搭建</p>
       <p>同学们在老师的指导下，同学们组织数据，规划利用简单的材料设计搭建迷你温室，过程中同学们通力协作，分工明确，搭建完成后同学们用温度计测试迷你温室搭建的效果，通过观察和比较，了解了不同变量对于温室效果影响。</p>
        <p class="imgGroup moreLine">
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-5-1.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-5-2.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-5-3.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-5-4.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-5-5.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-5-6.jpg")}"/>
       </p>
       <p>在活动的最后体验水培蔬菜采摘，因为水培技术能够精确控制植物所需的水分和养分，避免了土壤带来的病虫害风险，确保每一颗生菜都是自然与科技完美结合的产物。同学们不仅收获了食材，更收获了一份对自然的敬畏和对健康的承诺。</p>
     <p class="imgGroup moreLine">
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-6-1.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-6-2.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-6-3.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-6-4.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-6-5.jpg")}"/>
         <img loading="lazy" src="${require("../custom/clnyy/dataImgs/wz-8-6-6.jpg")}"/>
       </p>
       <p>让我们共同期待复选阶段小朋友们给我们带来更多惊喜！请持续关注我们的官方渠道获取最新资讯。</p>

      `
  },
]

// 活动风采数据
const hdfcData = [
  {
    id: 1, name: "数字农场 田间探奇 —— 低龄段", html: `
   <p><b>低龄段以“数字农场 田间探奇”为主题，</b>以实际体验先进的农业科技、学习现代农业知识为主线，向学生展示先进的农业技术、体验农业劳作，培养学生的动手能力。在体验中提高学生的综合素质，激发学生的科学创新和探索求知精神。</p>
    <p><img loading="lazy" src="${require('../../assets/custom/clnyy/dataImgs/hdfc-1.jpg')}" /></p>
    `},
  {
    id: 2, name: "智造农场 数创未来   ——  高龄段", html: `
    <p><b>高龄段以探究“智造农场 数创未来”为主题。</b>采用数字化技术的一般方法，从知识铺垫讲座、科普学习展览，到数字化生产农场参观、智能化设备体验，再到模拟农业专家，发现其中个别问题，并对具体问题进行分析、判断、推理，组织数据、制定解决方案。</p>
    <p><img loading="lazy" src="${require('../../assets/custom/clnyy/dataImgs/hdfc-2.jpg')}" /></p>
    `}
]

// 农艺园介绍数据
const nyyjsData = [
  { id: "1", thumb_image: require("../../assets/custom/clnyy/dataImgs/nyyjs-1.jpg"), text: "通过虚拟游园方式显示作物生长，同时融入了图像识别、农业机器人、等科技元素，学生可以通过人机互动沉浸式体验数字农业。", },
  {
    id: "2", thumb_image: require("../../assets/custom/clnyy/dataImgs/nyyjs-2.jpg"), text: "通过7x24小时温室光、温度、水分、空气的智能控制，实现园区育苗全程记录、科学管理、数字化控制目标，大幅提高设施蔬菜品质及产量。"
  },
  {
    id: "3", thumb_image: require("../../assets/custom/clnyy/dataImgs/nyyjs-3.jpg"), text: "应用几字槽支架＋椰糠基质的栽培模式及各类环境综合调控设备，可促进温室内换气及空气流通，保证温室内空气分布均匀。同时棚内还配有实时监测病虫害的安全生产监测设备，为科学绿色种植提供支撑，保证蔬菜的生产安全。",
    hasMore: true, showType: 1
  },
  {
    id: "4", thumb_image: require("../../assets/custom/clnyy/dataImgs/nyyjs-4.jpg"), text: "通过日光温室智能控制体系，精准控制温室温湿度、水肥、二氧化碳等环境参数，实现日光温室向智能温室的转变。"
  },
]



// 顶部轮播图
const bannerList = [
  require("../../assets/custom/clnyy/dataImgs/banner-1.jpg"),
]

// 农艺园介绍轮播图
const jsBannerList = [
  require("../../assets/custom/clnyy/dataImgs/js-banner-1.png"),
  require("../../assets/custom/clnyy/dataImgs/js-banner-2.png"),
  require("../../assets/custom/clnyy/dataImgs/js-banner-3.png"),
  require("../../assets/custom/clnyy/dataImgs/js-banner-4.png"),
]

export default {
  dsdtData,
  hdfcData,
  nyyjsData,
  bannerList,
  jsBannerList,
  hdbdData
}